import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons'; // Import the icon from Ant Design
import { useNavigate } from 'react-router-dom'; // Updated to useNavigate

const BackButton = () => {
  const navigate = useNavigate(); // useNavigate replaces useHistory

  const handleBack = () => {
    navigate(-1); // Equivalent to history.goBack() in react-router v6
  };

  return (
    <Button
      type="primary"
      onClick={handleBack}
      size="large" // Make the button bigger
      icon={<ArrowLeftOutlined />} // Add the Ant Design arrow icon
      style={{
        backgroundColor: 'black',
        borderColor: 'black',
        color: 'white',
        fontSize: '16px', // Increase font size for better readability
        padding: '10px 20px', // Add padding to make the button larger
      }}
    >
      Back
    </Button>
  );
};

export default BackButton;
